// extracted by mini-css-extract-plugin
export default {"footnote":"Footnote_footnote__4mNVr"};